export default __webpack_public_path__ + "static/media/bti-icon-active.0fcfc982.svg";